module.exports = __webpack_public_path__ + "static/media/qpxIcon.d0c2c5c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/qpxIcon.png
// module id = 678
// module chunks = 0 1